import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import TeamLogin from '@/components/TeamLogin'
import PinCodeLogin from '@/components/PinCodeLogin'
import ZooHomePage from '@/components/ZooHomePage'
import TeamLeaderboard from '@/components/TeamLeaderboard'
import Questions from '@/components/Questions'
import Question from '@/components/Question'
import Photos from '@/components/Photos'
import store from '../store/store'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/p/zoo',
      name: 'ZooHomePage',
      component: ZooHomePage
    },
    {
      path: '/g/:tenantId',
      name: 'TeamLogin',
      component: TeamLogin
    },
    {
      path: '/pin',
      name: 'PinCodeLogin',
      component: PinCodeLogin
    },
    {
      path: '/',
      name: 'TeamLogin',
      component: TeamLogin
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      beforeEnter: requireAuth
    },
    {
      path: '/questions',
      name: 'Questions',
      component: Questions,
      beforeEnter: requireAuth
    },
    {
      path: '/question/:id',
      name: 'Question',
      component: Question,
      beforeEnter: requireAuth
    },
    {
      path: '/teamleaderboard',
      name: 'TeamLeaderboard',
      component: TeamLeaderboard,
      beforeEnter: requireAuth
    },
    {
      path: '/photos',
      name: 'Photos',
      component: Photos,
      beforeEnter: requireAuth
    }
  ]
})

function requireAuth(to, from, next) {
  if (!store.getters.isLoggedIn) {
    console.log('Not authorised.. routing to login')
    next({
      path: '/',
      query: { redirect: to.fullPath }
    })
  } else {
    next()
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js